export default class Clippath {

    constructor(element) {
        if(!element) {
            return;
        }

        this.element = element;

        this.settings = {
            type: this.element.dataset.clippathType,
            elementPaddingTop: parseInt(getComputedStyle(this.element, null).getPropertyValue('padding-top')),
            elementPaddingBottom: parseInt(getComputedStyle(this.element, null).getPropertyValue('padding-bottom')),
            elementPadding: this.element.dataset.clippathPadding,
            angle: 3
        }

        this.multiplier = (100 / 45) * this.settings.angle;

        // Bind this to functions
        this.setClipPath = this.setClipPath.bind(this);

        this.setClipPath();
        this._setDOMReferences();
    }

    _setDOMReferences() {
        window.addEventListener("resize", this.setClipPath);
    }

    setClipPath() {
        const elementW = this.element.offsetWidth;
        const offset = (elementW / 100) * this.multiplier;
        const offsetRem = offset / 10;

        let clippath = "polygon(0px 0px, 100% 0px, 100% 100%, 0px 100%)";

        if(this.settings.type == 'point-bottom') {
            clippath = "polygon(0px 0px, 100% 0px, 100% calc(100% - "+ offsetRem + "rem), 50% 100%, 0 calc(100% - "+ offsetRem + "rem))";
        } else if (this.settings.type == 'point-bottom-inverse') {
            clippath = "polygon(0px 0px, 100% 0px, 100% 100%, 50% calc(100% - "+ offsetRem + "rem), 0 100%)";
        } else if (this.settings.type == 'point-bottom-double') {
            clippath = "polygon(0px 0px, 50% "+ offsetRem + "rem, 100% 0px, 100% calc(100% - "+ offsetRem + "rem), 50% 100%, 0 calc(100% - "+ offsetRem + "rem))";
        }

        this.element.style.clipPath = clippath;
        this.element.style.webkitClipPath = clippath;

        if(this.settings.elementPadding != "false") {
            this.element.style.paddingBottom = (this.settings.elementPaddingBottom / 10) + offsetRem +"rem";

            if (this.settings.type == 'point-bottom-double') {
                this.element.style.paddingTop = (this.settings.elementPaddingTop / 10) + offsetRem +"rem";
            }
        }
    }

}